import React from 'react';

/**
 * Local error boundary for the Square payment widget.
 * Prevents react-square-web-payments-sdk crashes (known React 19 incompat)
 * from blowing up the entire app via the global ErrorBoundary.
 */
class PaymentErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, retryKey: 0 };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('PaymentErrorBoundary caught:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState(s => ({ hasError: false, error: null, retryKey: s.retryKey + 1 }));
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-red-50 border border-red-200 p-4 space-y-3" data-testid="payment-error-boundary">
          <div className="flex items-start gap-3">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            <div className="flex-1">
              <p className="font-bold text-red-700 text-sm">Le module de paiement n'a pas pu se charger</p>
              <p className="text-xs text-red-600 mt-1">
                Cela peut etre du a un bloqueur (AdBlock, extension de navigateur) ou a un probleme reseau temporaire.
                Essayez de desactiver vos extensions ou de rafraichir la page.
              </p>
            </div>
          </div>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={this.handleRetry}
              className="px-3 py-1.5 bg-red-600 text-white text-xs font-bold hover:bg-red-700"
              data-testid="payment-retry-btn"
            >
              Reessayer
            </button>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="px-3 py-1.5 bg-white border border-red-300 text-red-700 text-xs font-bold hover:bg-red-50"
              data-testid="payment-refresh-btn"
            >
              Rafraichir la page
            </button>
          </div>
        </div>
      );
    }

    return (
      <React.Fragment key={this.state.retryKey}>{this.props.children}</React.Fragment>
    );
  }
}

export default PaymentErrorBoundary;
